import {handleActions} from 'redux-actions';
import actions from './category.actions';

const reducer = handleActions(
	{
		[actions.categoriesProviderLoaded]: (state, {payload}) => ({
			...state,
			provider: [...payload]
		}),
		[actions.categoriesCommunityLoaded]: (state, {payload}) => ({
			...state,
			community: [...payload]
		})
	},
	{
		provider: null,
		community: null
	}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/category/category.reducer.js